import { Form, Input } from 'admin-web-ui'
import { RuleRender } from 'rc-field-form/lib/interface'
import React, { useCallback, useState } from 'react'
import { PasswordValidationResult, validatePassword } from '../../utils/cognito'
import { PasswordFeedback } from './PasswordFeedback'

export interface ChangePasswordFieldsData {
  newPassword: string
  confirmPassword: string
}

interface Props {
  submitFailure?: boolean
}

export const ChangePasswordFields = (props: Props): JSX.Element => {
  const { submitFailure } = props
  const [validations, setValidations] = useState<PasswordValidationResult>(
    validatePassword(''),
  )

  const passwordFormatRule = useCallback<RuleRender>(
    () => ({
      validator: async (_rule, value) => {
        const newValidations = validatePassword(value || '')
        const passwordInvalid = Object.values(newValidations).some(
          (result) => result === false,
        )

        setValidations(newValidations)

        if (passwordInvalid) {
          throw new Error('Password does not meet criteria.')
        }
      },
    }),
    [setValidations],
  )

  const passwordConfirmRule = useCallback<RuleRender>(
    (form) => ({
      validator: async (_rule, value) => {
        if (value && value !== form?.getFieldValue('newPassword')) {
          throw new Error('Your passwords do not match.')
        }
      },
    }),
    [],
  )

  return (
    <>
      <Form.Item
        name="newPassword"
        validateStatus={submitFailure ? 'error' : undefined}
        rules={[
          { required: true, message: 'Please input your new password' },
          passwordFormatRule,
        ]}
      >
        <Input.Password
          placeholder="New password"
          autoComplete="new-password"
        />
      </Form.Item>

      <Form.Item
        name="confirmPassword"
        validateStatus={submitFailure ? 'error' : undefined}
        rules={[
          { required: true, message: 'Please confirm your new password' },
          passwordConfirmRule,
        ]}
      >
        <Input.Password placeholder="Confirm new password" />
      </Form.Item>

      <PasswordFeedback passwordValidations={validations} />
    </>
  )
}
